// Generated by scripts/generate.py. Do not edit.
export const VERSION_AVAILABILITIES = [
    "published",
    "deprecated",
    "withdrawn",
    "revoked",
];
